import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";
import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockSubtitle from "../../Block/BlockSubtitle";
import BlockText from "../../Block/BlockText";
import Block from "../../Block/Block";

function ADAM() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light">
        <BlockContent>
          <BlockTitle>ADAM Dataset</BlockTitle>
          <BlockSubtitle><b>A</b>ccurate <b>D</b>igital <b>A</b>nthropomorphic <b>M</b>odels</BlockSubtitle>
        </BlockContent>
        <BlockContent>
          <BlockText>A comprehensive collection of human body reconstructions will be generated utilising the 3D volumetric studio provided by Mantis Vision. This dataset, referred to as Accurate Digital Anthropomorphic Models (ADAM), offers a range of avatars specifically designed for the XR (Extended Reality) experience.</BlockText>
        </BlockContent>
      </Block>





      <Block>
        <BlockContent width="100%"  textAlign="center">
          <BlockTitle>Comming Soon</BlockTitle>
        </BlockContent>
      </Block>


  

      <Footer/>
    </div>
  );
}

export default ADAM;